import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = ({ data, onBookingClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        {data.backgroundVideo ? (
          <video 
            className="hero-video"
            autoPlay 
            loop 
            muted 
            playsInline
          >
            <source src={data.backgroundVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <div style={{ backgroundImage: `url(${data.backgroundImage})`, width: '100%', height: '100%' }} />
        )}
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-large">{data.name}</h1>
          <p className="hero-tagline">{data.tagline}</p>
          <p className="hero-description">{data.description}</p>
          <button className="btn-primary" onClick={onBookingClick}>
            {data.ctaText}
            <ArrowRight className="btn-icon-arrow" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;